import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledCobrandWrapper = styled.div`
  ${rtl`
    .variable_column_header {
      margin: 0;

      p {
        margin-bottom: 0;
      }
    }

    .cobrand-wrapper-height {
      min-height: ${toRem(4400)};

      @media ${baseVariables.mediaQuery.md} {
        min-height: ${toRem(6300)};
      }

      @media ${baseVariables.mediaQuery.lg} {
        min-height: ${toRem(5300)};
      }
    }

    .vcc-container {
      margin-bottom: 0;
    }

    .full-skeleton-block {
      border: ${baseVariables.border.borderWidth02} ${baseVariables.border.borderStyleDefault} ${
    baseVariables.color.neutral20
  };
      border-radius: ${toRem(16)};
      box-shadow: 0 ${toRem(4)} ${toRem(20)} ${baseVariables.shadows.boxShadowTile};
      overflow: hidden;

      .react-loading-skeleton {
        --pseudo-element-display: true;
      }
    }

    .personal-wrapper {
      @media ${baseVariables.mediaQuery.allTablets} {
        width: 100%;
        max-width: unset;
      }

      @media ${baseVariables.mediaQuery.xl} {
        width: 872px !important;
        max-width: 872px !important;
      }

      ul {
        max-width: fit-content;
      }
    }

    .business-wrapper {
      border-radius: ${toRem(14)};
      background-color: ${baseVariables.color.base20};
      box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
      padding-top: ${toRem(48)};

      @media ${baseVariables.mediaQuery.md} {
        width: max-content !important;
        max-width: max-content !important;
        margin: ${toRem(24)} auto 0 auto;
      }

      @media ${baseVariables.mediaQuery.lg} {
        padding-right: ${toRem(24)};
        padding-left: ${toRem(24)};
      }

      @media ${baseVariables.mediaQuery.xl} {
        max-width: ${toRem(242)} !important;
        padding-right: 0;
        padding-left: 0;
        margin-top: 0;
        margin-right: 0;
      }

      .layout-wrapper,
      .aem-container,
      .aem-container > div,
      .card-overview {
        height: 100%;
      }
    }

    .no-list-style ul {
      display: flex;
      list-style-type: none !important;
    }

    .card-tag {
      position: absolute;
      top: 0;
      left: 0;
      width: fit-content;
      padding: ${toRem(4)} ${toRem(16)};
      margin-bottom: ${toRem(24)};
      background-color: ${baseVariables.color.neutral30};
      text-transform: uppercase;
      line-height: ${toRem(14)};
      border-radius: ${toRem(8)} ${toRem(0)} ${toRem(4)} ${toRem(0)};
    }

    .business-badge {
      background-color: ${baseVariables.color.merch20};
      color: ${baseVariables.color.base20};
    }

    .column-containers {
      @media ${baseVariables.mediaQuery.lg} {
        padding-right: 0 !important;
        padding-left: 0 !important;
      }
    }

    .layout-wrapper {
      div.aem-container {
        padding-left: ${toRem(8)};
        padding-right: ${toRem(8)};

        @media ${baseVariables.mediaQuery.xl} {
          padding-left: 0;
          padding-right: 0;
        }
      }

      .column-containers,
      .aem-container:first-child {
        @media ${baseVariables.mediaQuery.md} {
          gap: 0;
        }
      }
    }
  `}
`;
